<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn
          text
          @click="$router.go(-1)"
          class="mb-4"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Zurück
        </v-btn>
        <v-card>
          <v-card-title>
            Neue Bankverbindung anlegen
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="bankAccount.name"
                    label="Name"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="bankAccount.iban"
                    label="IBAN"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="bankAccount.description"
                    label="Beschreibung"
                    rows="3"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="bankAccount.active"
                    label="Aktiv"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="bankAccount.ignore_for_processing"
                    label="Nicht verarbeiten"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="$router.go(-1)"
            >
              Abbrechen
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!valid || saving"
              :loading="saving"
              @click="save"
            >
              Anlegen
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-alert v-if="error" type="error" class="mt-4">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GET_TENANTS } from '@/modules/kirchgeld/store/kirchgeld/action-types'

export default {
  name: 'BankAccountCreate',
  data () {
    return {
      bankAccount: {
        name: '',
        iban: '',
        description: '',
        active: true,
        ignore_for_processing: false,
      },
      error: null,
      valid: false,
      saving: false,
      rules: {
        required: value => !!value || 'Pflichtfeld',
      }
    }
  },
  methods: {
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.saving = true
      this.error = null
      try {
        await this.$store.dispatch('kirchgeld/' + GET_TENANTS)
        const tenantUrl = this.$store.state.kirchgeld.tenant.url
        const response = await this.$store.getters['kirchgeld/api'].post(
          `${tenantUrl}bank_account/`,
          {
            name: this.bankAccount.name,
            iban: this.bankAccount.iban,
            description: this.bankAccount.description,
            active: this.bankAccount.active,
            ignore_for_processing: this.bankAccount.ignore_for_processing,
          }
        )
        this.$router.push({
          name: 'kige-bank-account-detail',
          params: { 'bank-account-id': response.data.id }
        })
      } catch (e) {
        this.error = 'Bankverbindung konnte nicht angelegt werden.'
        // eslint-disable-next-line
        console.error(e)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
</style>
